import { render } from "./Card.vue?vue&type=template&id=67216252&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=67216252&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67216252"

export default script